import { render, staticRenderFns } from "./MetalCalculator.vue?vue&type=template&id=12b27a45&scoped=true"
import script from "./MetalCalculator.vue?vue&type=script&lang=js"
export * from "./MetalCalculator.vue?vue&type=script&lang=js"
import style0 from "./MetalCalculator.vue?vue&type=style&index=0&id=12b27a45&prod&scoped=true&lang=css"
import style1 from "./MetalCalculator.vue?vue&type=style&index=1&id=12b27a45&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b27a45",
  null
  
)

export default component.exports